import "./HomePage.css";
import React from "react";
import MainContent from "../../components/MainContent/MainContent";
import Work from "../../components/work/work";
import CTA from "../../components/cta/cta";

function HomePage() {
  return (
    <>
      <MainContent />
      <Work />
      <CTA />
    </>
  );
}

export default HomePage;
